import {useRemoteAccessEnv} from '../env';
import {useFetchLockConditions} from './useFetchLockConditions';

function useRemoteAccessEnabled() {
  const {summary: data} = useRemoteAccessEnv();
  const {data: lockConditions} = useFetchLockConditions({
    enabled: Boolean(data?.is_remote_access_enabled),
  });

  return Boolean(
    data?.is_remote_access_enabled &&
      lockConditions?.is_show_keys_enabled &&
      lockConditions?.is_feature_active,
  );
}

export {useRemoteAccessEnabled};
